/** Canonical Teach APT PWA install identity — keep in sync with public/teach-manifest.json */
export const TEACH_PWA_MANIFEST_PATH = '/teach-manifest.json';
export const TEACH_PWA_ID = 'apt-teach-pwa';
export const TEACH_PWA_NAME = 'Teach APT';
export const TEACH_PWA_SHORT_NAME = 'Teach APT';
export const TEACH_PWA_START_URL = '/teach/';
export const TEACH_PWA_SCOPE = '/teach/';
export const TEACH_PWA_THEME_COLOR = '#d32f2f';

/** Colored APT mark on transparent alpha (parity with My APT). */
export const TEACH_PWA_APPLE_TOUCH_ICON = '/icons/icon-128x128-transparent.png';

export const TEACH_PWA_MANIFEST_ICONS = [
  {
    src: '/icons/icon-128x128-transparent.png',
    sizes: '128x128',
    type: 'image/png',
    purpose: 'any',
  },
  {
    src: '/icons/icon-128x128-transparent.png',
    sizes: '192x192',
    type: 'image/png',
    purpose: 'any',
  },
  {
    src: '/icons/icon-128x128-transparent.png',
    sizes: '512x512',
    type: 'image/png',
    purpose: 'any',
  },
] as const;

/** True for apex `/teach` routes and `teach.*` hosts. */
export function isTeachPwaSurface(pathname: string, hostname: string): boolean {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  if (normalizedPath === '/teach' || normalizedPath.startsWith('/teach/')) {
    return true;
  }
  const primaryLabel = hostname.split('.')[0]?.toLowerCase() ?? '';
  return primaryLabel === 'teach';
}
